import React, { useContext } from "react";
import classes from "./InfoBox.module.scss";
import colourClasses from "../../colour.module.scss";
import GoalContext from "../../store/goal-context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLightbulb, faCircle } from '@fortawesome/free-solid-svg-icons'

const InfoBox = (props) => {
    const goalContext = useContext(GoalContext);
    const goalIsActive = goalContext.activeGoal;
    const infoBoxGoalActive = goalIsActive ? classes.active : '';
    let locationInfo = null;
    let activeGoal = null;
    let selectedLocation = null;

    if(goalContext.activeGoal !== null) {
        activeGoal = goalContext.goals[goalIsActive - 1]
        locationInfo = activeGoal.locations[goalContext.activeLocation];
        selectedLocation = goalContext.activeLocation;
    }

    const colour = activeGoal ? `colour--${activeGoal.primary_colour}` : 'colour--black';

    return (
        <section className={`${classes['info-box']} ${infoBoxGoalActive} ${colourClasses[colour]}`}>
            {
                !locationInfo && !activeGoal &&
                <>
                    <h2>Sustainable Dundee Map</h2>
                    <p>The United Nations Sustainable Development Goals (SDG's) are an urgent call to action to end poverty, protect the planet, and ensure that by 2030 all people enjoy peace and prosperity. The 17 Goals are connected, which means that action in on area will affect outcomes in others. Sustainable Dundee is a city-wide initiative to tackle the Climate Emergency locally and is fully aligned with the UN SDG's.</p>
                    <p>This map gives an overview of local initiatives in relation the UN SDG's</p>
                    <p><strong>Select a goal on the left to learn about Dundee initiatives.</strong></p>
                </>
            }
            {
                activeGoal && 
                <>
                    <h2>Sustainable Dundee Map</h2>
                    <h3>{`Goal ${goalContext.activeGoal}: ${activeGoal.description}`}</h3>
   
                    {
                        goalContext.goals[goalIsActive - 1].locations[0].points &&
                        <>
                            <h4>Things To Do</h4>
                            <ul>
                                {
                                    goalContext.goals[goalIsActive - 1].locations[0].points.map((point, index) => (
                                        <li key={index}>
                                            <span className="fa-layers fa-fw" size="2x">
                                                <FontAwesomeIcon className={classes.bullet} size="2x" icon={faCircle} />
                                                <FontAwesomeIcon className={classes.lightbulb} size="1x" icon={faLightbulb} />
                                            </span>
                                            <div className={classes.point}>{point.item}</div>
                                        </li>
                                    ))
                                }
                            </ul>
                        </>
                    }
                </>
            }
        </section>
    )
}

export default InfoBox;